(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snippet-localization-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const localizationButtons = document.querySelectorAll('.localization-btn');
    const localizationDropdowns = document.querySelectorAll('.localization-dropdown');
    
    // Toggle dropdown on button click (mobile and desktop)
    localizationButtons.forEach((button, index) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const dropdown = button.nextElementSibling;
        const isOpen = dropdown.style.opacity === '1';
        
        // Close all dropdowns
        localizationDropdowns.forEach(d => {
          d.style.opacity = '0';
          d.style.visibility = 'hidden';
          d.style.transform = 'translateY(-10px)';
        });
        
        // Toggle current dropdown
        if (!isOpen) {
          dropdown.style.opacity = '1';
          dropdown.style.visibility = 'visible';
          dropdown.style.transform = 'translateY(0)';
        }
      });
    });
    
    // Handle dropdown item clicks
    localizationDropdowns.forEach(dropdown => {
      dropdown.addEventListener('click', function(e) {
        if (e.target.classList.contains('localization-dropdown__item')) {
          const form = e.target.closest('form');
          if (form) {
            form.submit();
          }
        }
      });
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.localization-selector__language') && 
          !e.target.closest('.localization-selector__country')) {
        localizationDropdowns.forEach(dropdown => {
          dropdown.style.opacity = '0';
          dropdown.style.visibility = 'hidden';
          dropdown.style.transform = 'translateY(-10px)';
        });
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
